// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"dc60180f","213":"6612a08b","351":"f5e0eeca","667":"f1f72031"}[chunkId] + ".chunk.js";
};